import AnalyticsHome from "../views/Analytics/AnalyticsHome";

const navRoutesAnalytics = [
  { path: "/", exact: true, name: "Home", component: AnalyticsHome },
  { path: "/analytics", exact: true, name: "Home", component: AnalyticsHome },
];

export default navRoutesAnalytics;
